import type React from 'react';
import { News as SharedNews } from '../../shared/news/News';

export const News: React.FC<{ labId: string }> = ({ labId }) => {
  return <SharedNews labId={labId} />;
};
